import React from 'react';
import { OptionProps } from 'react-select';
import cn from 'classnames';

import { TNameTitle } from '@interfaces/common/common';

import { getCellColor } from './constants';

import styles from './PrioritySelectOption.module.scss';

const PrioritySelectOption = (props: OptionProps<TNameTitle>) => {
	const {
		selectOption,
		data: { title, name },
	} = props;

	const handleSelect = () => {
		selectOption(props.data);
	};

	const cellColor = getCellColor(name);

	return (
		<div
			className={cn(styles.presetsOption, {
				[styles.active]: props.isSelected,
			})}
			onClick={handleSelect}
		>
			<div
				className={styles.colorCell}
				style={{ background: cellColor }}
			/>
			<div className={styles.label}>
				{title}
			</div>
		</div>
	);
};

export default PrioritySelectOption;
